var AppSettings = {
    apiHostUrl : "https://progress.prismict.com/customer-profile-api/api"
};
module.exports = {AppSettings};